import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBackOfficePerson = (paginate) => {
  return http.get(
    `${getBaseUrl()}/back_office_person?${paginate}`
  );
};

export const submitBackOfficePerson = (data) => {
  http.hasFile();
  return http.post(
    `${getBaseUrl()}/back_office_person`,
    data
  );
};

export const updateBackOfficePerson = (data) => {
  http.hasFile();
  return http.put(
    `${getBaseUrl()}/back_office_person`,
    data
  );
};

